module.exports = __webpack_public_path__ + "static/media/home-background-artiste-big.d43f7e46.webp";